export const animationDuration = '0.4s'
export const animationTimingFunction = 'ease-in-out'
